import { useLogto } from '@logto/react';
import { useCallback } from 'react';

import { hasPortalConnector } from '@/utils/portal-session';

import useRedirectUri from './use-redirect-uri';

/** The embedded Devportal uses its configured OIDC connector. Standalone login remains available. */
export default function useConsoleSignIn() {
  const { signIn } = useLogto();
  const redirectUri = useRedirectUri();

  return useCallback(
    async (signUp = false) => {
      if (!signUp && (await hasPortalConnector())) {
        return signIn({
          redirectUri,
          directSignIn: { method: 'social', target: 'devportal-sso' },
          // Inherit the console login and consent prompts so offline_access is granted.
        });
      }

      return signIn(redirectUri.href, signUp ? 'signUp' : undefined);
    },
    [redirectUri, signIn]
  );
}
